/*
 * TC 필터/정렬 — 정렬 select 변경 시 sort_by 파라미터로 이동.
 * (다른 필터 파라미터는 유지, page는 초기화)
 */
(function () {
  function init() {
    document.querySelectorAll('select[data-tc-sort]').forEach(function (sel) {
      if (sel.dataset.tcBound === '1') return;
      sel.dataset.tcBound = '1';
      sel.addEventListener('change', function () {
        if (!this.value) return;
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', this.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
